import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';

class ProductSpecificationsContent extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateSpecificationsContent);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateSpecificationsContent);
  }

  /**
   * Updates the specifications content from the variant-updated section HTML.
   * @param {VariantUpdateEvent} event
   */
  updateSpecificationsContent = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newSpecificationsContent = event.detail.data.html.querySelector(
      `product-specifications-content[data-block-id="${this.dataset.blockId}"]`,
    );

    if (!newSpecificationsContent) return;

    morph(this, newSpecificationsContent, { childrenOnly: true });
  };
}

if (!customElements.get('product-specifications-content')) {
  customElements.define('product-specifications-content', ProductSpecificationsContent);
}
